export const pending = () => new Promise<never>(() => null);
